// @flow
import React from 'react';

import { INLINE_1, INLINE_2, INLINE_4 } from 'Components/frameworks/card/Card.constants';
import { mapColToCard } from 'Components/utils/cards/cards.utils';

import { Card } from 'Components/frameworks/card/Card.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

const LEFT = 'left';

type Props = {
  ...$Exact<CMSCard>,
  config: CMSContent,
  id?: string,
  mediaPosition: 'left' | 'right',
};

export function MediaTextHorizontalLine({ id, mediaPosition, ...rest }: Props) {
  return (
    <SiteContainer className="Line" id={id}>
      {rest.mediaUrl ? (
        <Card {...mapColToCard(rest)} layout={mediaPosition === LEFT ? INLINE_1 : INLINE_2} />
      ) : (
        <Card {...mapColToCard(rest)} layout={INLINE_4} />
      )}
    </SiteContainer>
  );
}
